module.exports = __webpack_public_path__ + "static/media/print.8f2cc6fa.svg";